import { getPdfLinkSaga } from './getPdfLink'

const pdfSagas = [getPdfLinkSaga]

export default pdfSagas
